export default "/images/379595763d9e1251fb9087fbfbc660b3.png";